import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { StudioDetails } from "@/components/site/StudioDetails";
import { Packages } from "@/components/site/Packages";
import { Vouchers } from "@/components/site/Vouchers";
import { EnquirySection } from "@/components/site/EnquirySection";
import { Terms } from "@/components/site/Terms";
import { Footer } from "@/components/site/Footer";
import { SocialDock } from "@/components/site/SocialDock";
import { Gallery } from "@/components/site/Gallery";
import { InstagramFeed } from "@/components/site/InstagramFeed";
import AdminPage from "@/pages/Admin";

const LandingPage = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <StudioDetails />
      <Packages />
      <Vouchers />
      <Gallery />
      <InstagramFeed />
      <EnquirySection />
      <Terms />
    </main>
    <Footer />
    <SocialDock />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
